import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Home from "@/views/Home.vue";
import HomePage from "@/views/HomePage.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "*",
        redirect: "/",
    },
    {
        path: "/verify",
        component: () => import("@/views/Verify.vue"),
        name: "verify",
        meta: { autherizedAndNotVerified: true },
    },
    {
        path: "/verify-email",
        component: () => import("@/views/VerifyEmail"),
        name: "verify-email",
        meta: { publicPage: true },
    },
    {
        path: "/verify-mobile",
        component: () => import("@/views/VerifyMobile"),
        name: "verify-mobile",
        meta: { autherizedAndNotVerified: true },
    },
    {
        path: "/sign-up",
        component: () => import("@/views/SignUp"),
        name: "sign-up",
        meta: { unautherized: true },
    },
    {
        path: "/verify-data",
        component: () => import("@/views/verifyData"),
        name: "verify-data",
        meta: { publicPage: true },
    },
    {
        path: "/about-us",
        component: () => import("@/views/about-us"),
        name: "about-us",
        meta: { publicPage: true },
    },
    {
        path: "/privacy-policy",
        component: () => import("@/views/PrivacyPolicy"),
        name: "privacy-policy",
        meta: { publicPage: true },
    },
    {
        path: "/terms-conditions",
        component: () => import("@/views/TermsAndConditions"),
        name: "terms-conditions",
        meta: { publicPage: true },
    },
    {
        path: "/terms-of-service",
        component: () => import("@/views/TermsOfService"),
        name: "terms-of-service",
        meta: { publicPage: true },
    },
    {
        path: "/verfication-methods",
        component: () => import("@/views/verificationMethods"),
        name: "verfication-methods",
        meta: { autherizedAndNotVerified: true },
    },
    {
        path: "/sign-in",
        component: () => import("@/views/SignIn"),
        meta: { unautherized: true },
        children: [
            {
                path: "",
                redirect: "email",
                meta: { unautherized: true },
            },
            {
                path: "email",
                component: () =>
                    import("@/components/SignIn/SignInFormEmail.vue"),
                name: "sign-in-email",
                meta: { unautherized: true },
            },
            {
                path: "password",
                component: () =>
                    import("@/components/SignIn/signInFormPassword.vue"),
                name: "sign-in-password",
                meta: { unautherized: true },
            },
            {
                path: "forget-password",
                component: () =>
                    import("@/components/SignIn/ForgetPasswordForm.vue"),
                name: "forget-password",
                meta: { unautherized: true },
            },
        ],
    },
    // {
    //     path: "/forget-password",
    //     component: ForgetPassword,
    //     name: "forget-password",
    // },
    {
        path: "/reset-password/:id",
        component: () => import("@/views/ResetPassword"),
        name: "reset-password",
        meta: { unautherized: true },
    },
    {
        path: "/",
        name: "home",
        redirect: { name: "my-shipment" },
        component: Home,
        children: [
            // {
            //     path: "/home",
            //     component: HomePage,
            //     name: "homepage",
            //     meta: { publicPage: true },
            // },
            {
                path: "send-shipment",
                component: () => import("@/views/SendShipment"),
                name: "send-shipment",
                meta: { autherizedAndVerified: true },
            },
            {
                path: "view-order/:id",
                component: () => import("@/views/ViewOrder"),
                name: "view-order",
                meta: { autherizedAndVerified: true },
            },
            {
                path: "my-shipment",
                component: () => import("@/views/MyShipment"),
                name: "my-shipment",
                meta: { autherizedAndVerified: true },
            },
            {
                path: "archived-shipments",
                component: () => import("@/views/ArchivedShipments"),
                name: "archived-shipments",
                meta: { autherizedAndVerified: true },
            },
            {
                path: "my-addresses",
                component: () => import("@/views/MyAddresses"),
                name: "my-addresses",
                meta: { autherizedAndVerified: true },
            },
            {
                path: "checkout/:id",
                component: () => import("@/views/checkout"),
                name: "checkout",
                meta: { autherizedAndVerified: true },
            },
            {
                path: "invoice-checkout/:id",
                component: () => import("@/views/invoice-checkout"),
                name: "checkout",
                meta: { autherizedAndVerified: true },
            },
            {
                path: "transaction",
                component: () => import("@/views/transaction"),
                name: "transaction",
                meta: { autherizedAndVerified: true },
            },
            {
                path: "invoice-transaction",
                component: () => import("@/views/invoice-transaction"),
                name: "invoice-transaction",
                meta: { autherizedAndVerified: true },
            },
            {
                path: "all-transactions",
                component: () => import("@/views/AllTransactions"),
                name: "all-transactions",
                meta: { autherizedAndVerified: true },
            },
            {
                path: "add-credit",
                component: () => import("@/views/addCredit"),
                name: "add-credit",
                meta: { autherizedAndVerified: true },
            },
            {
                path: "invoices",
                component: () => import("@/views/Invoices"),
                name: "invoices",
                meta: { autherizedAndVerified: true },
            },
            {
                path: "invoice-details",
                component: () => import("@/views/InvoiceDetails"),
                name: "invoice-details",
                meta: { autherizedAndVerified: true },
            },
        ],
    },
    {
        path: "/my-profile",
        component: () => import("@/views/myProfile"),
        name: "my-profile",
        meta: { autherizedAndVerified: true },
        // redirect: { name: "homepage" },
    },
    {
        path: "/invoice/:id",
        component: () => import("@/views/Invoice"),
        name: "invoice",
        meta: { autherizedAndVerified: true },
    },
    {
        path: "/request-address",
        component: () => import("@/views/requestAddress"),
        name: "request-address",
        meta: { autherizedAndVerified: true },
    },
    {
        path: "/shipment-details/:id",
        component: () => import("@/views/ShipmentDetails"),
        name: "shipment-details",
        meta: { autherizedAndVerified: true },
    },
    // {
    //     path: "/shipment-options",
    //     component: () => import("@/views/shipmentOptions"),
    //     name: "shipment-options",
    //     meta: { autherizedAndVerified: true },
    //     redirect: { name: "send-shipment" },
    // },
    // {
    //     path: "/send-shipment/:type",
    //     component: () => import("@/views/ShipmentNewWays/main"),
    //     name: "sendshipment-type",
    //     meta: { autherizedAndVerified: true },
    //     // redirect: { name: "destinations" },
    //     redirect: { name: "send-shipment" },
    //     children: [
    //         {
    //             path: "destinations",
    //             name: "destinations",
    //             component: () => import("@/views/ShipmentNewWays/Destinations"),
    //         },
    //         {
    //             path: "weight-dimensions",
    //             name: "weight-dimensions",
    //             component: () =>
    //                 import("@/views/ShipmentNewWays/WeightDimensions"),
    //         },
    //         {
    //             path: "shipment-description",
    //             name: "shipment-description",
    //             component: () =>
    //                 import("@/views/ShipmentNewWays/ShipmentDescription"),
    //         },
    //         {
    //             path: "shipment-summary",
    //             name: "shipment-summary",
    //             component: () =>
    //                 import("@/views/ShipmentNewWays/ShipmentSummary"),
    //         },
    //     ],
    // },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    const publicPage = to.matched.some((record) => record.meta.publicPage);
    const unautherized = to.matched.some((record) => record.meta.unautherized);
    const autherizedAndNotVerified = to.matched.some(
        (record) => record.meta.autherizedAndNotVerified
    );
    const autherizedAndVerified = to.matched.some(
        (record) => record.meta.autherizedAndVerified
    );
    const authorized = store.state.user.authorized;
    const mobile_verified = store.state.user.mobile_verified;
    const email_verified = store.state.user.email_verified;
    const is_updated = store.state.userData.is_updated;

    if (autherizedAndVerified) {
        if (authorized) {
            if (mobile_verified && email_verified) {
                // if (is_updated) {
                next();
                // } else {
                //     next("/verify-data");
                // }
            } else {
                next("/verify");
            }
        } else {
            next("/sign-in");
        }
    } else if (autherizedAndNotVerified) {
        if (authorized) {
            if (!mobile_verified || !email_verified) {
                next();
            } else {
                next("/my-shipment");
            }
        } else {
            next("/sign-in");
        }
    } else if (unautherized) {
        if (!authorized) {
            next();
        } else {
            next("/my-shipment");
        }
    } else if (publicPage) {
        next();
    } else {
        next();
    }
});

export default router;
